import { Component, HostBinding, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { map, take, tap } from 'rxjs/operators'
import { AuthManager } from 'src/app/shared/auth/AuthManager'
import { GrowthToolkitClient, PracticeMetric } from 'src/app/shared/services/ppv.api'
import { GrowthToolkitActionItemListComponent } from '../action-item-list/action-item-list.component'
import { MatDialog } from '@angular/material/dialog'
import { BookingModalComponent } from 'src/app/shared/components/booking-modal/booking-modal.component'
import { MeetingSchedulerModalComponent } from 'src/app/shared/components/meeting-scheduler-modal/meeting-scheduler-modal.component'

@Component({
   selector: 'regional-manager-hospital',
   templateUrl: './regional-manager-hospital-page.component.html',
   styleUrls: ['./regional-manager-hospital-page.component.scss'],
   standalone: false,
})
export class GrowthToolkitRegionalManagerHospitalPage implements OnInit {
   @HostBinding('class.full-flex-height') fullFlexHeight = true
   @ViewChild(GrowthToolkitActionItemListComponent) actionItemListComponent!: GrowthToolkitActionItemListComponent

   practiceSKeyNumber = 0
   practiceName = ''
   rmName = ''

   hospitalRow: any = null

   //prettier-ignore
   constructor(
      private authManager: AuthManager,
	  private router: Router,
      private route: ActivatedRoute,
      private growthToolkitClient: GrowthToolkitClient,
	  private dialog: MatDialog
   ) {}

   ngOnInit(): void {
      //parse the url params
      const param = this.route.paramMap.subscribe((params) => {
         this.practiceSKeyNumber = Number(params.get('practiceSKey'))
      })

      this.fetchHospitalRow()

      this.authManager
         .getCurrentUser()
         .pipe(
            take(1),
            map((user) => {
               const match = user.practices.find((p) => p?.id === this.practiceSKeyNumber)
               return match?.nameId ?? ''
            })
         )
         .subscribe((nameId: string | null) => {
            this.practiceName = nameId
         })
   }

   onSaveDraftClick(): void {
      console.log('saving draft of action items')

      //save the action items as a draft
      this.saveActionItems(false)
   }

   onPublishPageClick(): void {
      console.log('publishing action items')

      //publish the action items
      this.saveActionItems(true)
   }

   saveActionItems(isPublished: boolean): void {
      //get the values from the expandable row subcomponents
      const actionItemValues = this.actionItemListComponent.getActionItemsToSave()

      const practiceSKey = this.practiceSKeyNumber

      //TODO: update this to something better, just a placeholder for now
      const twoWeeksFromNow = new Date()
      twoWeeksFromNow.setDate(twoWeeksFromNow.getDate() + 14)

      //populate the metrics to save
      const metrics: PracticeMetric[] = []

      actionItemValues.forEach((item) => {
         //  console.log(item)

         metrics.push({
            practiceSKey: practiceSKey,
            taskId: item.taskId,
            startValue: item.currentValue,
            targetValue: item.targetValue,
            startDate: new Date(),
            targetDate: twoWeeksFromNow,
            notes: '',
            isActive: item.isActive,
            isPublished: isPublished || item.isPublished,
         })
      })

      //save these items to the db
      this.growthToolkitClient.saveMetricsForPractice(practiceSKey, metrics).subscribe({
         next: () => console.log('Auto-saved'),
         error: (err) => console.error('Auto-save failed', err),
      })
   }

   openMeetingSchedulerModal(): void {
      this.growthToolkitClient.getHospitalInfo(this.practiceSKeyNumber).subscribe((data) => {
         this.rmName = data.rmDisplayName

         this.dialog.open(MeetingSchedulerModalComponent, {
            panelClass: 'booking-drawer-panel',
            autoFocus: false,
            disableClose: true,
            data: {
               rmName: this.rmName,
			   subject: "Leadership Toolkit Meeting",
            },
         })
      })
   }

   openBookingModal(): void {
      this.growthToolkitClient.getHospitalInfo(this.practiceSKeyNumber).subscribe((data) => {
         this.rmName = data.rmDisplayName

         this.dialog.open(BookingModalComponent, {
            panelClass: 'booking-drawer-panel',
            autoFocus: false,
            disableClose: true,
            data: {
               rmName: this.rmName,
            },
         })
      })
   }

   public fetchHospitalRow(): void {
      this.growthToolkitClient.getAvailablePractices(this.practiceSKeyNumber).subscribe({
         next: (data) => {
            this.hospitalRow = data[0]
            console.log(this.hospitalRow)
         },
         error: (error) => {
            console.error('Error fetching hospital data: ', error)
         },
      })
   }
}
